import { formatBuildLabel } from '@klareospace/pharos-lib-utils';
import { version } from '../../package.json';

/** Build label shown in the sidebar user menu, e.g. `v2.0.0 - 5a17cfb`. */
export function getAppVersionLabel(): string {
  // __GIT_SHA__ is only injected by the Vite `define` config — Vitest doesn't build through it.
  const commitSha = typeof __GIT_SHA__ !== 'undefined' ? __GIT_SHA__ : '';
  return formatBuildLabel({ commitSha, version });
}
